import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { Notification } from 'base-ui'

export const FixedPriceDifferencePanel: FC = () => {
  const i18n = useIntl()

  return (
    <Notification
      className="my-4 bg-light-primary-low"
      severity="info"
      title={i18n.formatMessage({
        id: 'productPricing.modal.productSection.fixedAmount.title',
      })}
    >
      <FormattedMessage id="productPricing.modal.productSection.fixedAmount.content" />
    </Notification>
  )
}
